module.exports = {"id":"220029","name":"Saîf-Eddine Khaoui","rating":"71","photo":"./data/images/photos/4/220029.png","club":{"name":"ESTAC Troyes","logo":"./data/images/clubs/ESTACTroyes.png"},"positions":["MOC","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Saif-EddineKhaoui0.json
// module id = 3773
// module chunks = 0